import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ColumnState } from '@store/models/column-state.model';

export const selectColumnState = createFeatureSelector<ColumnState>('columnState');

export const selectTableColumnState = (tableId: string) => createSelector(selectColumnState, (columnState) => columnState.tables[tableId] || []);
